import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "admin-branding" }
const _hoisted_2 = { class: "tab-content" }
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = { class: "tab-content" }
const _hoisted_5 = { class: "footer-content" }
const _hoisted_6 = { class: "footer-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_AdGridView = _resolveComponent("AdGridView")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_AdSettings = _resolveComponent("AdSettings")!
  const _component_ERP_CompaniesGrid = _resolveComponent("ERP_CompaniesGrid")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_footer = _resolveComponent("v-footer")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        color: _ctx.APP_Color,
        elevation: "0",
        height: "64",
        class: "super-admin-bar"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              color: "white",
              size: "28",
              class: "mr-3"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-shield-crown", -1)
              ]))]),
              _: 1
            }),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "branding-text" }, [
              _createElementVNode("span", { class: "admin-title" }, "Super Admin"),
              _createElementVNode("span", { class: "admin-subtitle" }, "Panou de Administrare")
            ], -1))
          ]),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_chip, {
            color: _ctx.APP_Color,
            variant: "outlined",
            size: "small",
            class: "version-chip"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                size: "14",
                class: "mr-1"
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("mdi-shield-check", -1)
                ]))]),
                _: 1
              }),
              _cache[5] || (_cache[5] = _createTextVNode(" Privilegii Complete ", -1))
            ]),
            _: 1
          }, 8, ["color"]),
          _createVNode(_component_v_btn, {
            variant: "text",
            onClick: _ctx.logout,
            class: "logout-btn",
            "prepend-icon": "mdi-logout"
          }, {
            default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
              _createTextVNode(" Deconectare ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["color"]),
      _createVNode(_component_v_main, { class: "admin-main" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, {
            fluid: "",
            class: "admin-container"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, {
                class: "tabs-card",
                elevation: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tabs, {
                    modelValue: _ctx.selectedIndex,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedIndex) = $event)),
                    color: _ctx.APP_Color,
                    class: "modern-tabs",
                    "align-tabs": "start"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
                        return (_openBlock(), _createBlock(_component_v_tab, {
                          key: index,
                          value: index,
                          class: "tab-item"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              icon: tab.icon,
                              size: "20",
                              class: "mr-2"
                            }, null, 8, ["icon"]),
                            _createTextVNode(" " + _toDisplayString(tab.text), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "color"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card, {
                class: "content-card",
                elevation: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_window, {
                    modelValue: _ctx.selectedIndex,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedIndex) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_window_item, { value: 0 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_AdGridView)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, { value: 1 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_AdSettings)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_window_item, { value: 2 }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_ERP_CompaniesGrid)
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_footer, {
        class: "admin-footer",
        app: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _cache[7] || (_cache[7] = _createElementVNode("span", { class: "footer-text" }, "© 2025 Else Digital Solutions S.R.L.", -1)),
            _createVNode(_component_v_divider, {
              vertical: "",
              class: "mx-3"
            }),
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "footer-text" }, "Super Admin Panel", -1)),
            _createVNode(_component_v_divider, {
              vertical: "",
              class: "mx-3"
            }),
            _createElementVNode("span", _hoisted_6, "v" + _toDisplayString(_ctx.APP_Version), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}